/**
 * Copyright (c) 2018 itemis AG - All rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 *
 * Contributors:
 * 	andreas muelder - itemis AG
 *
 */

import * as ace from "ace-builds";
import "ace-builds/src-noconflict/ext-language_tools";
import "ace-builds/src-noconflict/theme-monokai";
import "ace-builds/src-noconflict/theme-tomorrow";
import "./stext-mode";
import { PreferenceStore } from "../services/preference-store";
import { setSyntaxHighlighting } from "./ace-settings";

export const DARK_MODE_THEME = "ace/theme/monokai";
export const LIGHT_MODE_THEME = "ace/theme/tomorrow";

export class AceFactory {
  static createEmbeddedEditor(container: HTMLElement, opt?: AceFactoryOptions): ace.Ace.Editor {
    const editor = ace.edit(container);

    editor.setTheme(opt.darkMode ? DARK_MODE_THEME : LIGHT_MODE_THEME);
    setSyntaxHighlighting(editor, opt && opt.showDocumentation);
    editor.container.style.background = "rgba(255, 255, 255, 0)";
    editor.renderer.setPadding(opt?.padding || 2);
    if (opt && opt.showGutter) {
      editor.renderer.setShowGutter(true);
    } else {
      editor.renderer.setShowGutter(false);
    }
    editor.setOptions({
      enableBasicAutocompletion: true,
      showLineNumbers: false,
      highlightActiveLine: false,
      wrap: true,
      cursorStyle: "smooth",
      behavioursEnabled: true,
      hasCssTransforms: true,
      fontFamily: PreferenceStore.INSTANCE.theme.model.text.fontFamily,
      fontSize: 10,
    });
    const renderer = editor.renderer;
    renderer.setShowPrintMargin(false);
    editor.commands.addCommand({
      name: "Close",
      exec: function () {
        editor.blur();
      },
      bindKey: { mac: "esc", win: "esc" },
    });
    return editor;
  }
}

export class AceFactoryOptions {
  showGutter?: boolean = false;
  padding?: number = 2;
  darkMode?: boolean = false;
  showDocumentation?: boolean = false;
}
